module.exports = __webpack_public_path__ + "static/media/app design (1).bbbebece.png";